import type { NodeCategory } from '@bandos/shared'

/**
 * Get the target category and label based on the source node's category.
 */
export function getTargetInfo(sourceCategory?: NodeCategory): {
  targetCategory: NodeCategory
  targetLabel: string
} | null {
  if (!sourceCategory) return null

  if (sourceCategory === 'venture') {
    return { targetCategory: 'need', targetLabel: 'Unmet need' }
  }
  if (sourceCategory === 'need') {
    return { targetCategory: 'idea', targetLabel: 'Idea' }
  }
  if (sourceCategory === 'idea') {
    return { targetCategory: 'idea', targetLabel: 'Idea' }
  }

  return null
}
